import { Component, Input, OnInit } from "@angular/core";

import { SharedService } from "@shared/services/shared.service";

import { AdminService } from "app/services/admin/admin.service";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { Subscription } from "rxjs";


@Component({
  selector: 'complaint-businessDetails',
  styleUrls: ['./businessDetails.component.scss'],
  templateUrl: './businessDetails.component.html'
})

export class ComplaintBusinessDetailsComponent implements OnInit {

  @Input() businessId: number = 0;

  complaintSubscription: Subscription;

  constructor(
    private complaintService: ComplaintService
  ) {

  }

  ngOnInit(): void {
    this.complaintSubscription = this.complaintService.updateEvent.subscribe((data: number) => {
      if (data == 2) {
        this.init();
      }
    });
  }

  ngOnDestroy() {
    this.complaintSubscription.unsubscribe();
  }
   
  init(){
  }

  
}